import CalcalistPaywallMyAccountPersonalDetails from "./calcalistPaywallMyAccountPersonalDetails"
import CalcalistPaywallMyAccountLastPurchases from "./calcalistPaywallMyAccountpLastPurchases"
import CalcalistPaywallMyAccountTabs from "./calcalistPaywallMyAccountTabs";
import { useEffect, useState } from "react";
import { useRedirect } from "../../../../../global/paywall/useRedirect";
import { getPaywallSettingsFromLocalStorage } from "../../../../../global/paywall/authOperations";
import { getPersonalCustomerDetails } from "../../../../../global/paywall/paywallApiUrls";
import * as axios from "axios";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces"

const CalcalistPaywallMyAccountComponenta = (props: { authPageUrl: string, contactUsPage:{url:string,targetLink:LinkTargetProperties} }) => {

    const { authPageUrl, contactUsPage} = props;
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [userData, setUserData] = useState<any>(null);

    useRedirect({ fallbackUrl: authPageUrl, enabled: shouldRedirect });

    const checkUserAccess = async () => {
            const userDetails = getPaywallSettingsFromLocalStorage();
            if (!userDetails && !shouldRedirect) { 
                setShouldRedirect(true);
            }else{
                const { data } = await getUserData(getPersonalCustomerDetails()) as any;
                setUserData(data);
            }
    };

    useEffect(() => {
        if (!shouldRedirect) {  
            checkUserAccess();
        }
    }, []);

    const getUserData = async (url: string) => {
        try {
            const response = await axios.get(url); 
            return response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const tabs = [
        {
            label: "המשתמש שלי",
            content: <CalcalistPaywallMyAccountPersonalDetails userData={userData} />,
        },
        {
            label: "רכישות אחרונות",
            content: <CalcalistPaywallMyAccountLastPurchases userData={userData} contactUsPage={contactUsPage} />,
        },
    ];

    return (
        <div className="CalcalistPaywallMyAccountComponenta">
            { userData && <CalcalistPaywallMyAccountTabs tabs={tabs} />}
        </div>
    );

};

export default CalcalistPaywallMyAccountComponenta;

CalcalistPaywallMyAccountComponenta.siteScriptName = "CalcalistPaywallMyAccountComponenta"

